function init() {
	function animateNumber(element) {
		const targetValue = parseInt(element.getAttribute("data-number"), 10);
		const duration = 2000; // Durata dell'animazione in millisecondi
		const startValue = 0;
		const startTime = performance.now();

		function updateNumber(timestamp) {
			const progress = Math.min((timestamp - startTime) / duration, 1);
			const currentValue = Math.floor(
				startValue + (targetValue - startValue) * progress
			);

			// Formatta il numero con separatore delle migliaia
			const formattedNumber = currentValue.toLocaleString();

			// Mantiene i <span> interni e aggiorna solo il testo numerico
			element.childNodes.forEach((child) => {
				if (child.nodeType === Node.TEXT_NODE) {
					child.textContent = formattedNumber; // Modifica solo il testo numerico
				}
			});

			if (progress < 1) {
				requestAnimationFrame(updateNumber); // Continua l'animazione finché non è completa
			}
		}

		requestAnimationFrame(updateNumber);
	}

	// Funzione per il controllo di visibilità dell'elemento
	function handleIntersection(entries, observer) {
		entries.forEach((entry) => {
			if (
				entry.isIntersecting &&
				!entry.target.classList.contains("animated")
			) {
				animateNumber(entry.target);
				entry.target.classList.add("animated"); // Imposta una classe per evitare ripetizioni
				observer.unobserve(entry.target); // Fermiamo l'osservazione dell'elemento dopo che ha animato
			}
		});
	}

	// Impostazione dell'osservatore di intersezione
	function createObserver() {
		return new IntersectionObserver(handleIntersection, {
			threshold: 0.5, // Triggera quando almeno il 50% dell'elemento è visibile
		});
	}

	// Inizializza l'osservatore
	const observer = createObserver();

	// Funzione per osservare gli elementi con data-number
	function observeElements() {
		const elements = document.querySelectorAll("p[data-number]");
		elements.forEach((element) => {
			observer.observe(element); // Inizia a osservare l'elemento
		});
	}

	observeElements();
}

export default { init };
